import api from './index';

export default {
  index(params) {
    return api({
      method: 'get',
      url: `api/accounts`,
      params,
    });
  },
  getById(id, params) {
    return api({
      method: 'get',
      url: `api/accounts/${id}`,
      params,
    });
  },
  create(body) {
    return api({
      method: 'post',
      url: `api/accounts`,
      data: body,
    });
  },
  update(id, body) {
    return api({
      method: 'put',
      url: `api/accounts/${id}`,
      data: body,
    });
  },
  resyncBalance(id, body) {
    return api({
      method: 'post',
      url: `api/accounts/${id}/sync-balance`,
      data: body,
    });
  },
};
